const cache = new Map();

/**
 * Marca deixada nos erros deste módulo: o gerador troca o toast genérico por
 * "Arte indisponível para o ZIP" quando o download da arte é o que falhou.
 */
export const isArtPngFailure = (error) => Boolean(error?.artPngFailure);

/** Baixa o PNG aprovado (URL presigned; bucket com CORS GET). Cache por URL na sessão. */
export const fetchArtPngBytes = async (url) => {
  if (cache.has(url)) return cache.get(url);
  const p = fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error(`Arte indisponível (${res.status})`);
      return res.arrayBuffer();
    })
    .then((b) => new Uint8Array(b))
    .catch((e) => {
      cache.delete(url);
      if (e && typeof e === "object") e.artPngFailure = true;
      throw e;
    });
  cache.set(url, p);
  return p;
};
